import useBreakpoint from "./useBreakpoint";

/**
 * useBreakpointUp is a custom hook that checks if the window's width is greater than or equal to a specified breakpoint.
 * @param {number} breakpoint - The breakpoint to check against.
 * @returns {boolean} The current status of the breakpoint (true if the window's width is greater than or equal to the breakpoint, false otherwise).
 */
const useBreakpointUp = (breakpoint) => {
    const status = useBreakpoint(`(min-width:${breakpoint}px)`);
    return status;
};

export default useBreakpointUp;
